// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"871c25b6","455":"d90031e0","977":"0216a576"}[chunkId] + ".chunk.js";
};